/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagDto } from '../../models/tag-dto';

export interface TagControllerDelete$Params {
  id: string;
}

export function tagControllerDelete(http: HttpClient, rootUrl: string, params: TagControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<TagDto>> {
  const rb = new RequestBuilder(rootUrl, tagControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagDto>;
    })
  );
}

tagControllerDelete.PATH = '/api/tags/{id}';
